import React from "react";
import { Progress, Card, Button } from "antd";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useProcess } from "../../contexts/ProcessContext";
import monoGenoma from "../../assets/mono-genoma.png";
import "./styles.scss";

export default function ProcessDetail() {
  const history = useHistory();
  const { t } = useTranslation();
  const {
    loading,
    candidateName,
    processId,
    interviewInfo,
  } = useProcess();

  const testRedirect = () => {
    history.push({
      pathname: `/processes/${processId}/test`,
    });
  };

  if (loading) {
    return (
      <div className="pd">
        <Progress percent={100} status="active" showInfo={false} />
      </div>
    );
  }

  return (
    <div className="pd">
      <Card
        className="card home"
        title={
          <div>
            <img src={monoGenoma} width="120" alt="" />
            <h1>{t("frontvint__welcome_title", { name: candidateName })}</h1>
          </div>
        }
      >
        <div className="card-content">
          <p className="welcome-text">
            {t("frontvint__welcome_description")}
            <br />
            {t("frontvint__welcome_video_privacy")}
          </p>
          <div className="int-button">
            <Button onClick={testRedirect}>
              {t("frontvint__start_interview_button")}
            </Button>
          </div>
          <div className="int-tips">
            <div className="wrap">
              <h2>{t("frontvint__what_to_expect_title")}</h2>
              <div className="pd__list">
                <div className="pd__list__item">
                  {t("frontvint__expect_time_per_question")}
                </div>
                <div className="pd__list__item">
                  {interviewInfo?.questionMaxAttempts > 1
                    ? t("frontvint__expect_two_attempts")
                    : t("frontvint__expect_one_attempt")}
                </div>
                <div className="pd__list__item">
                  {interviewInfo?.flashInterview
                    ? t("frontvint__expect_flash_interview")
                    : t("frontvint__expect_read_before_record")}
                </div>
              </div>
            </div>
            <div className="wrap second">
              <h2>{t("frontvint__tips_title")}</h2>
              <div className="pd__list">
                <div className="pd__list__item">
                  {t("frontvint__tip_chrome")}
                </div>
                <div className="pd__list__item">
                  {t("frontvint__tip_connection")}
                </div>
                <div className="pd__list__item">
                  {t("frontvint__tip_environment")}
                </div>
                <div className="pd__list__item">
                  {t("frontvint__tip_camera")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
}
